<template>
  <v-btn color="primary" elevation="0" @click="openCreateHausefulUser">
    <v-icon left>mdi-plus</v-icon>
    <span class="d-none d-md-flex body-2">
      {{ $t('hausefulUsers.action.create') }}
    </span>
  </v-btn>
</template>

<script>
export default {
  name: 'HausefulUsersHeaderActions',

  methods: {
    openCreateHausefulUser() {
      const openCreateCustomerModal = this.$parent?.$parent?.$refs.usersRouterView
      openCreateCustomerModal?.openCreateEdit()
    }
  },
}
</script>
